import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import axios from "axios";
import { useEffect } from "react";
import {
  CapacitorPreferencesConstants,
  EndpointsConstants,
  MetricConstants,
  MetricTypeConstants,
} from "../components/Constants";
import OneOverlayLoader from "../utils/component-utils/OverlayLoader/OneOverlayLoader";
import { setCapacitorPreference } from "../utils/core-utils/capPreferencesUtils";
import { startMetric } from "../utils/metric-utils/metricUtils";
import { BE_URL } from "../utils/urlUtils";
import { getOrCreateStickySessionId } from "../utils/stickySessionIdManager";

// @author E42303 Judhjit Ganguli

interface MobileAppAuthProps {
  accessTokenfetched: Function;
}

const MobileAppAuth: React.FC<MobileAppAuthProps> = ({
  accessTokenfetched,
}) => {
  useEffect(() => {
    postAuthCode();
  }, []);

  async function postAuthCode() {
    startMetric(
      MetricConstants.TIME_TO_FIRST_PAINT_LOGIN,
      MetricTypeConstants.TIMER,
    );
    const stickySessionCleintId = await getOrCreateStickySessionId();
    const params = {
      "x-sticky-session-id": stickySessionCleintId,
    };
    const json = await axios.post(
      BE_URL + EndpointsConstants.AUTH_ENDPOINT,
      {
        code: window.location.href.split("=")[1],
        format: "json",
      },
      { params: params },
    );
    let accessToken = "";
    if (json.data && typeof json.data === "object") {
      if (json.data.access_token) {
        accessToken = json.data.access_token.replaceAll("\'", "");
      }
      if (json.data.refresh_token) {
        setCapacitorPreference(
          CapacitorPreferencesConstants.REFRESH_TOKEN,
          json.data.refresh_token,
        );
      }
    } else if (typeof json.data === "string") {
      accessToken = json.data.replaceAll("\'", "");
    }
    setCapacitorPreference(
      CapacitorPreferencesConstants.ACCESS_TOKEN,
      accessToken,
    );
    console.log("accessToken" + "=" + accessToken);
    accessTokenfetched();
  }

  return (
    <IonPage>
      {/* <IonHeader className='ion-no-border'>
        <IonToolbar>
          <IonTitle></IonTitle>
        </IonToolbar>
      </IonHeader> */}
      <IonContent>
        <OneOverlayLoader
          loadingText={["Authenticating....."]}
          shouldDisplayLogoAndSlogan={true}
        />
      </IonContent>
    </IonPage>
  );
};

export default MobileAppAuth;
